import { useCallback } from "react";

import { addImport } from "fond/redux/imports";
import { featureCollection } from "fond/turf";
import { MuPowerSolverLayerIds } from "fond/types";
import { removeDrawingProperties } from "fond/utils/geojson";
import { useAppDispatch, useAppSelector } from "fond/utils/hooks";
import { isImportInProgress } from "fond/utils/layers";

import { usePhaseNetwork } from "./usePhaseNetwork";

/**
 * Seed the phase overrides layer with the solver's phase decision points.
 */
export const useSeedPhaseOverrides = (versionId: string) => {
  const dispatch = useAppDispatch();

  const { network, isLoading } = usePhaseNetwork(versionId);
  const { decisionPoints } = network;

  const hasDecisionPoints = decisionPoints.length > 0;

  const importStates = useAppSelector((state) => state.imports[versionId]);
  const isSeeding = isImportInProgress(importStates?.[MuPowerSolverLayerIds.phaseOverrides]?.status);

  const seedPhaseOverrides = useCallback(async () => {
    if (decisionPoints.length === 0) return;
    const file = new File([JSON.stringify(removeDrawingProperties(featureCollection(decisionPoints)))], "layer.geojson", {
      type: "application/geo+json",
    });
    await dispatch(addImport({ versionId, layerKey: MuPowerSolverLayerIds.phaseOverrides, displayName: "Phase overrides", files: [file] }));
  }, [decisionPoints, dispatch, versionId]);

  return { hasDecisionPoints, isSeeding, isLoading, seedPhaseOverrides };
};
